import { useEffect, useState } from "react";
import { Localized } from "@fluent/react";
import { Alert, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useAppDispatch } from "../../../../app/hooks";
import { CancelButton } from "../../../../app/components/CancelButton";
import { YesButton } from "../../../../app/components/YesButton";
import {
    DocumentWorkflowDefinitionDto,
    removeDocumentTeamMemberFromStage,
} from "../documentWorkflowApi";

type DeleteWorkflowStageMemberDialogProps = {
    open: boolean;
    documentId?: number | string | null;
    stageId?: number;
    userName?: string;
    memberName?: string;
    stageTitle?: string;
    onSuccess: (definition: DocumentWorkflowDefinitionDto) => void;
    onCancel: () => void;
};

export const DeleteWorkflowStageMemberDialog = ({
    open,
    documentId,
    stageId,
    userName,
    memberName,
    stageTitle,
    onSuccess,
    onCancel,
}: DeleteWorkflowStageMemberDialogProps) => {
    const dispatch = useAppDispatch();
    const [isDeleting, setIsDeleting] = useState(false);
    const [serverError, setServerError] = useState("");

    useEffect(() => {
        if (open) {
            setIsDeleting(false);
            setServerError("");
        }
    }, [open]);

    const getServerErrorMessage = (result: any) => {
        let errorMsg = "error";
        if (result.payload && result.payload.kind === "http") {
            const problem = result.payload.problem;
            if (problem?.title) {
                errorMsg = problem.title;
            }
        }
        return errorMsg;
    };

    const handleConfirm = async () => {
        if (!documentId || !stageId || !userName || isDeleting) {
            return;
        }

        setIsDeleting(true);
        setServerError("");

        const result = await dispatch(
            removeDocumentTeamMemberFromStage({
                documentId: String(documentId),
                stageId: String(stageId),
                userName,
            })
        );

        if (removeDocumentTeamMemberFromStage.fulfilled.match(result)) {
            onSuccess(result.payload);
        } else {
            setServerError(getServerErrorMessage(result));
        }

        setIsDeleting(false);
    };

    return <Dialog open={open} fullWidth maxWidth="xs">
        <DialogTitle>Usun z etapu</DialogTitle>
        <DialogContent>
            <Alert severity="warning" sx={{ mt: 1 }}>
                {`Czy na pewno usunac ${memberName ?? "tego usera"} z etapu ${stageTitle ?? ""}?`}
            </Alert>
            {serverError && (
                <Alert severity="error" sx={{ mt: 1 }} onClose={() => setServerError("")}>
                    <Localized id={serverError}>
                        <span>{serverError}</span>
                    </Localized>
                </Alert>
            )}
        </DialogContent>
        <DialogActions>
            <YesButton loading={isDeleting} onClick={handleConfirm} disabled={isDeleting || !documentId || !stageId || !userName} />
            <CancelButton loading={isDeleting} onClick={onCancel} disabled={isDeleting} />
        </DialogActions>
    </Dialog>;
};
